import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../context/appContext";
import { useSearchContext } from "../context/search";

export default function ProtectedRoute({ search = false, children }) {
	const { items } = useAppContext();
	const { isUserLogin } = items;

	const {
		state: { phrase },
	} = useSearchContext();

	if (typeof isUserLogin !== "boolean") {
		return null; 
	}
	if (!isUserLogin) {
		return <Navigate to="/" replace></Navigate>;
	}
	if (phrase !== "" && !search) return <Navigate to="/search" replace></Navigate>;
	return children;
}

ProtectedRoute.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	search: PropTypes.bool,
};
